<template>
	<div class="full-chat-left">
		<div class="os-tabs-w">
			<ul class="nav nav-tabs upper centered">
				<li class="nav-item">
					<a class="nav-link active" data-toggle="tab" href="#tab_overview"><i class="os-icon os-icon-mail-14"></i><span>Chats</span></a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-toggle="tab" href="#tab_sales"><i class="os-icon os-icon-ui-93"></i><span>Contacts</span></a>
				</li>
				<li class="nav-item">
					<a class="nav-link" data-toggle="tab" href="#tab_sales"><i class="os-icon os-icon-ui-02"></i><span>Favorites</span></a>
				</li>
			</ul>
		</div>
		<div class="chat-search">
			<div class="element-search">
				<input placeholder="Search users by name..." type="text">
			</div>
		</div>
		<div class="user-list" :class="(convs) ? '' : 'blurred'">

			<div v-for="c in convs" v-if="convs">
				<router-link class="waves-effect" :to="{ name: 'conversation', params: {id: c.tid} }" active-class="activeC" >
					<div class="user-w">
						<div class="avatar with-status status-green">
							<ProfilePic :w="40" :h="40" :c="'#00000'" v-if="c.username"/>
						</div>
						<div class="user-info" :class="(c.unread > 0) ? 'isbold' : ''">
							<div class="user-date" v-if="c.lastMessageDate">
								{{  c.lastMessageDate | timeAgo }}
							</div>
							<div class="user-name" v-if="c.userFullName">
								{{ getParticipants(c.participant) }}
							</div>
							<div class="user-name" v-else-if="c.username">
								{{ c.username }}
							</div>
							<div class="last-message">

								{{ c.subject }}
								<div class="unread-count float-right" v-if="c.unread > 0">
									{{  c.unread }}
								</div>
							</div>

						</div>
					</div>
				</router-link>
			</div>

		</div>

	</div>
</template>

<script>
    import ProfilePic from '@/components/user/ProfilePic'

    export default {
        components: { ProfilePic },
        name: 'Conversations',
        data () {
            return {
                session: session,
                convsLoader: true,
                convs: [],
	            selectedConv: this.$route.params.id
            }
        },
	    mounted () {
            this.checkDirectMessage()
            this.fetchConversations()
	    },
        watch: {
            '$route.params.id': function (cid) {
                this.fetchConversations(cid)
            }
        },
	    methods: {
            checkDirectMessage () {

                if (this.$route.params.uid) {
                    this.$http.get(api+'api/v1/conversation/check_user/'+this.$route.params.uid
                    ).then(response => {
                        var m = response.body.result.conversation[0];

                    this.$router.push({ name: 'conversation', params: {id: m.tid} });

                }, response => {
                        // error callback

                        this.$http.get(api+'api/v1/user/meta/'+this.$route.params.uid
                        ).then(response => {
                            var u = response.body.result;

							this.convs.unshift({
							    isDeleted: false,
							    isSpam: false,
							    lastMessageDate: false,
							    participant: [
							        {
							            id: u.id,
							            userFullName: u.name,
							            username: u.username
							        }
							    ],
							    tid: this.$route.params.id,
							    uid: u.id,
							    unread: 0,
							    userFullName: u.name,
							    username: u.username

							});

                        }, response => {
                            // error callback

                        })



                    })
                }

            },
            fetchConversations (cid = 0) {
                this.convsLoader = (cid) ? false : true;
                this.$http.get(api+'api/v1/message/conversation?cid='+cid,
                ).then(response => {
                    if(cid > 0) {
                        this.convs[cid] = response.body.result.conversations[cid];
                        this.convsLoader = false;
                    }else {
                        // get body data
                        this.convs = Object.values(response.body.result.conversations);
                        this.$emit('conversations', response.body.result.conversations);
                        this.convsLoader = false;

                    }
                }, response => {
                    // error callback

                })
            },
            getParticipants (Participants) {
                var pname = new Array;

                Participants.forEach(function(p) {
                    if(p.id != session.uid) {
                        pname.push(p.userFullName);
                    }

                });

                return pname.join(',');
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.full-chat-w .full-chat-left .user-list .user-w .avatar {
		margin-right: 0px;
	}
	.full-chat-w .full-chat-left .user-list .user-w .unread-count {
		float: right;
		padding: 2px 7px;
		background-color: #ff4f4f;
		border-radius: 12px;
		font-size: 0.72rem;
		color: rgba(0, 0, 0, 0.3);
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
		color: #fff;
		text-align: center;
		width: 25px
	}

	.full-chat-w .full-chat-left .user-list .user-w {
		padding: 10px 10px;
	}
	.isbold {
		font-weight: bold !important;
		color: #000;
	}

	.activeC .user-w {
		background: #047bf8;
		color: white;
	}

	.full-chat-w .full-chat-left .user-list .user-w .user-date {
		float: right;
		padding: 2px 7px;
		background-color: #fff;
		border-radius: 12px;
		font-size: 0.72rem;
		color: rgba(0, 0, 0, 0.3);
		-webkit-transition: all 0.2s ease;
		transition: all 0.2s ease;
	}
</style>



// WEBPACK FOOTER //
// src/components/message/Conversations.vue